import { useEffect, useState } from "react";
import styles from "../Components/ProductList.module.css"
import Api from "../api/ecomApi";
const YourProfile = ()=> {
    let loggedInId = localStorage.getItem('user_id');
    const [address,setAddress] = useState({});
    const [userName, setUserName] = useState();
    useEffect(()=>{
        Api.get(`customer-details/${loggedInId}/`)
        .then((response) => {
          //console.log(response.data[0])
          setAddress(response.data[0]);
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
      Api.get(`user-details/${loggedInId}/`)
        .then((response) => {
            const fullName = response.data[0].first_name + ' ' + response.data[0].last_name
          setUserName(fullName);
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });

    }, [])
    return <>
    <div className={`col-sm-12 ${styles.mainContainer}`}>
          <div className="container-fluid">
            <div className="col-sm-10">
              <h4>Your Profile</h4>
              <h6>Name : {userName}</h6>
              <h6>Address : {address.address} {address.city} {address.pin_code}</h6>              
              <h6>Mobile No: {address.mobile_no}</h6>
            </div>
          </div>
        </div>
    </>
}
export default YourProfile; 